/**
 * Show modal lookbook
 */

if (!customElements.get('tpt-group-product-trigger')) {
	customElements.define(
		'tpt-group-product-trigger',
		class TptLookbookTrigger extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showLookbookModal.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.showLookbookModal();
				}
			}

			showLookbookModal() {
				const modalId = this.getAttribute('data-target');
				const activeItem = this.getAttribute('data-active');
				const modal = document.getElementById(modalId);
				modal._triggerElement = this;
				modal.classList.add('show');
				document.getElementsByTagName('html')[0].classList.add('open-modal');

				document.querySelectorAll('.tpt-group-product__modal-item').forEach((item) => {
					item.classList.remove('active');

					document.getElementById(activeItem).classList.add('active');
				});

				setTimeout(() => {
					console.log(modal);
					const focusElement = modal.querySelector('[data-close="modal"]');
					trapFocus(modal, focusElement);
				}, 300);
			}
		}
	);
}

/**
 * Next prev button
 */

if (!customElements.get('tpt-lookbook-button')) {
	customElements.define(
		'tpt-lookbook-button',
		class TptLookbookButton extends HTMLElement {
			constructor() {
				super();

				this.sliderContainer = this.closest('.tpt-group-product__slider');
				this.firstSlide = this.sliderContainer.querySelector('.tpt-group-product__modal-item:first-child');
				this.lastSlide = this.sliderContainer.querySelector('.tpt-group-product__modal-item:last-child');

				this.addEventListener('click', this.nextPrevItem.bind(this));
			}

			removeActiveAll() {
				this.sliderContainer.querySelectorAll('.tpt-group-product__modal-item').forEach((item) => {
					item.classList.remove('active');
				});
			}

			activeSlide(activeElement) {
				this.removeActiveAll();
				activeElement.classList.add('active');
			}

			nextPrevItem() {
				const buttonType = this.getAttribute('data-type');
				const currentSlideActive = this.sliderContainer.querySelector('.tpt-group-product__modal-item.active');
				const nextSlideActive = currentSlideActive.nextElementSibling;
				const prevSlideActive = currentSlideActive.previousElementSibling;

				if (buttonType == 'next') {
					if (nextSlideActive) {
						this.activeSlide(nextSlideActive);
					} else {
						this.removeActiveAll();
						this.firstSlide.classList.add('active');
					}
				} else {
					if (prevSlideActive) {
						this.activeSlide(prevSlideActive);
					} else {
						this.removeActiveAll();
						this.lastSlide.classList.add('active');
					}
				}
			}
		}
	);
}
